import {
    GET_FILES_LIST_REQUEST,
    GET_FILES_LIST_SUCCESS,
    GET_FILES_LIST_FAILURE,
    GET_FILE_REQUEST,
    GET_FILE_SUCCESS,
    GET_FILE_FAILURE,
    SEARCH_FILES_LIST_SUCCESS,
    CLEAR_DETAIL_DATA,
    SEARCH_FILES_DISABLE,
    SEARCH_FILES_LIST_FETCHING,
    GET_FILE_BY_PROJECT_REQUEST,
    GET_FILE_BY_PROJECT_SUCCESS,
    GET_FILE_BY_PROJECT_FAILURE,
    CLEAR_PROJECT_FILES,
    SET_FILTER
} from './actions';
import {
    SIGN_OUT
} from '../auth/actions';

const initialState = {
    isFetching: false,
    isFetched: false,
    list: false,
    details: {},
    projectFiles: false,
    searchResult: [],
    searchEnabled: false,
    isSearchFetching: true,
    filter: false,
    timestamp: +new Date()
};

export default function filesReducer (state = initialState, action) {
    switch(action.type){
        case GET_FILES_LIST_REQUEST: {
            return {
                ...state,
                isFetching: true
            }
        }
        case GET_FILES_LIST_SUCCESS: {
            let files = {};
            let currentPayload = action.payload.files || action.payload;
            Object.keys(currentPayload).map((projectId) => {
                for(let fileId in currentPayload[projectId]){
                    // console.log('object assign', currentPayload);
                    files[fileId] = Object.assign(currentPayload[projectId][fileId], {projectId});
                }
            });
            return {
                ...state,
                list: files,
                isFetching: false,
                isFetched: true
            }
        }
        case GET_FILES_LIST_FAILURE: {
            return {
                ...state,
                isFetching: false
            }
        }
        case GET_FILE_REQUEST: {
            return {
                ...state,
                isFetching: true
            }
        }
        case GET_FILE_SUCCESS: {
            return {
                ...state,
                details: action.payload,
                isFetching: false
            }
        }
        case GET_FILE_FAILURE: {
            return {
                ...state,
                isFetching: false
            }
        }
        case SEARCH_FILES_LIST_FETCHING: {
            return {
                ...state,
                searchResult: [],
                isSearchFetching: true
            }
        }
        case SEARCH_FILES_LIST_SUCCESS: {
            return {
                ...state,
                searchResult: action.payload,
                searchEnabled: true,
                isSearchFetching: false,
                timestamp: +new Date()
            }
        }
        case SEARCH_FILES_DISABLE: {
            return {
                ...state,
                searchResult: [],
                searchEnabled: false,
                isSearchFetching: false
            }
        }
        case CLEAR_DETAIL_DATA: {
            return {
                ...state,
                details: {}
            }
        }
        case GET_FILE_BY_PROJECT_REQUEST: {
            return {
                ...state,
                isFetching: true
            }
        }
        case GET_FILE_BY_PROJECT_SUCCESS: {
            if (Object.keys(action.payload || {}).length > 0){
                Object.keys(action.payload).map((fileId) => {
                    action.payload[fileId].projectId = action.projectId;
                });
            }

            return {
                ...state,
                projectFiles: action.payload,
                isFetching: false
            }
        }
        case GET_FILE_BY_PROJECT_FAILURE: {
            return {
                ...state,
                isFetching: false
            }
        }
        case CLEAR_PROJECT_FILES: {
            return {
                ...state,
                projectFiles: false
            }
        }
        case SIGN_OUT: {
            return {
                ...initialState
            }
        }
        case SET_FILTER: {
            return {
                ...state,
                filter: action.payload
            }
        }
        default: {
            return {...state};
        }
    }
}
